export default "__VITE_PUBLIC_ASSET__6d4678ad__"